module.exports = __webpack_public_path__ + "img/Hands_Logo_Branco.5f5e0813.png";